/**
 * "Toegevoegd aan winkelwagen" popover
 * Intercepts the product-table and swatches add-to-cart forms, adds the
 * selected products via AJAX, and shows a dismissible popover instead of
 * reloading the page.
 */
document.addEventListener('DOMContentLoaded', function () {
    const popover = document.querySelector('.js-cart-popover');

    if (!popover) {
        return;
    }

    const timerBar = popover.querySelector('.js-cart-popover-timer');
    const messageEl = popover.querySelector('.js-cart-popover-message');
    const listEl = popover.querySelector('.js-cart-popover-list');
    const errorsEl = popover.querySelector('.js-cart-popover-errors');
    const closeBtn = popover.querySelector('.js-cart-popover-close');
    const continueBtn = popover.querySelector('.js-cart-popover-continue');

    const AUTO_DISMISS_MS = 5000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const genericErrorMessage = 'Er ging iets mis bij het toevoegen aan je winkelwagen.';

    let remaining = AUTO_DISMISS_MS;
    let timerStartedAt = 0;
    let dismissTimeout = null;
    let isTimerPaused = false;
    let isSubmitting = false;

    function getAjaxUrl() {
        return (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.ajax_url) ? decolegnoAjax.ajax_url : ajax_object.ajax_url;
    }

    function getNonce() {
        return (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) ? decolegnoAjax.nonce : '';
    }

    function updateCartCount(count) {
        const displayCount = count > 99 ? '99+' : String(count);
        const headerCartIconSelector = [
            '.l-header__section__right__icon-bar__icon.icon-cart',
            '.l-header__section__right__icon-bar__icon.icon-cart-open',
            '.l-mobile-header__top__icon.icon-cart',
            '.l-mobile-header__top__icon.icon-cart-open',
        ].join(', ');

        // Mobile header omits badge markup when the cart starts empty server-side.
        document.querySelectorAll('.l-mobile-header__top__icon.icon-cart').forEach(function (icon) {
            if (count <= 0 || icon.querySelector('.cart-count')) {
                return;
            }

            icon.classList.remove('icon-cart');
            icon.classList.add('icon-cart-open');

            const wrapper = document.createElement('span');
            wrapper.className = 'l-mobile-header__top__icon__cart';

            const countEl = document.createElement('span');
            countEl.className = 'cart-count';
            countEl.textContent = displayCount;

            wrapper.appendChild(countEl);
            icon.appendChild(wrapper);
        });

        // Only header badges — never touch order-table / footer cart icons.
        document.querySelectorAll('.l-header .cart-count, .l-mobile-header .cart-count').forEach(function (el) {
            el.textContent = count > 0 ? displayCount : '';
        });

        document.querySelectorAll(headerCartIconSelector).forEach(function (icon) {
            icon.classList.toggle('icon-cart-open', count > 0);
            icon.classList.toggle('icon-cart', count <= 0);
            icon.classList.toggle('cart-count--active', count > 0);
        });
    }

    function renderItems(items) {
        listEl.innerHTML = '';

        items.forEach(function (item) {
            const li = document.createElement('li');
            li.className = 'c-cart-popover__item';

            const img = document.createElement('img');
            img.className = 'c-cart-popover__item__image';
            img.src = item.thumbnail;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 64;
            img.height = 64;

            const info = document.createElement('div');
            info.className = 'c-cart-popover__item__info';

            const title = document.createElement('p');
            title.className = 'c-cart-popover__item__title';
            title.textContent = item.title;

            info.appendChild(title);

            if (item.collection) {
                const collection = document.createElement('p');
                collection.className = 'c-cart-popover__item__collection';
                collection.textContent = item.collection;
                info.appendChild(collection);
            }

            const qty = document.createElement('p');
            qty.className = 'c-cart-popover__item__qty';
            qty.textContent = item.quantity + item.unit;

            li.appendChild(img);
            li.appendChild(info);
            li.appendChild(qty);
            listEl.appendChild(li);
        });
    }

    function startTimer(duration) {
        clearTimeout(dismissTimeout);
        remaining = duration;
        timerStartedAt = Date.now();
        isTimerPaused = false;
        dismissTimeout = setTimeout(closePopover, remaining);

        if (prefersReducedMotion || !timerBar) {
            return;
        }

        timerBar.style.transition = 'none';
        timerBar.style.width = '100%';
        // Force a reflow so the width transition below actually animates.
        void timerBar.offsetHeight;
        timerBar.style.transition = 'width ' + remaining + 'ms linear';
        timerBar.style.width = '0%';
    }

    function stopTimer() {
        clearTimeout(dismissTimeout);
        dismissTimeout = null;
        isTimerPaused = false;

        if (!timerBar) {
            return;
        }

        timerBar.style.transition = 'none';
        timerBar.style.width = '100%';
    }

    function pauseTimer() {
        if (!popover.classList.contains('is-open') || popover.classList.contains('is-loading') || isTimerPaused) {
            return;
        }

        if (!dismissTimeout) {
            return;
        }

        isTimerPaused = true;
        clearTimeout(dismissTimeout);
        dismissTimeout = null;
        const elapsed = Date.now() - timerStartedAt;
        remaining = Math.max(remaining - elapsed, 0);

        if (prefersReducedMotion || !timerBar) {
            return;
        }

        const computedWidth = getComputedStyle(timerBar).width;
        timerBar.style.transition = 'none';
        timerBar.style.width = computedWidth;
    }

    function resumeTimer() {
        if (!popover.classList.contains('is-open') || popover.classList.contains('is-loading') || !isTimerPaused) {
            return;
        }

        isTimerPaused = false;

        if (remaining <= 0) {
            closePopover();
            return;
        }

        timerStartedAt = Date.now();
        dismissTimeout = setTimeout(closePopover, remaining);

        if (prefersReducedMotion || !timerBar) {
            return;
        }

        void timerBar.offsetHeight;
        timerBar.style.transition = 'width ' + remaining + 'ms linear';
        timerBar.style.width = '0%';
    }

    function positionPopoverBelowHeader() {
        const isMobile = window.innerWidth <= 1023;
        const header = document.querySelector(isMobile ? '.l-mobile-header' : '.l-header');

        if (!header) {
            return;
        }

        const spacing = isMobile ? 16 : 24;
        const bottom = Math.max(header.getBoundingClientRect().bottom, 0);
        popover.style.top = (bottom + spacing) + 'px';
    }

    function renderErrors(messages) {
        errorsEl.innerHTML = '';

        if (!messages.length) {
            popover.classList.remove('has-errors');
            return;
        }

        messages.forEach(function (message) {
            const p = document.createElement('p');
            // Messages are sanitized server-side with wp_kses_post so links
            // (e.g. Customer Support) stay clickable.
            p.innerHTML = message;
            errorsEl.appendChild(p);
        });

        popover.classList.add('has-errors');
    }

    function openPopoverLoading() {
        messageEl.textContent = '';
        listEl.innerHTML = '';
        renderErrors([]);
        positionPopoverBelowHeader();
        popover.classList.remove('is-error');
        popover.classList.add('is-open', 'is-loading');
        popover.setAttribute('aria-busy', 'true');
        stopTimer();
    }

    function openPopover(data) {
        const items = data.items || [];
        const errors = data.errors || [];
        // Each line counts as one product; quantities and units stay on the row.
        const count = items.length;

        messageEl.textContent = count === 1
            ? 'Product toegevoegd aan je winkelwagen'
            : count + ' producten toegevoegd aan je winkelwagen';

        renderItems(items);
        renderErrors(errors);
        positionPopoverBelowHeader();
        popover.classList.remove('is-loading', 'is-error');
        popover.removeAttribute('aria-busy');
        popover.classList.add('is-open');

        // Partially rejected orders need reading time, so skip the countdown.
        if (errors.length) {
            stopTimer();
            return;
        }

        startTimer(AUTO_DISMISS_MS);
    }

    function openPopoverError(messages) {
        messageEl.textContent = 'Niet toegevoegd aan je winkelwagen';
        listEl.innerHTML = '';
        renderErrors(messages);
        positionPopoverBelowHeader();
        popover.classList.remove('is-loading');
        popover.removeAttribute('aria-busy');
        popover.classList.add('is-open', 'is-error');
        stopTimer();
    }

    window.addEventListener('scroll', function () {
        if (popover.classList.contains('is-open')) {
            positionPopoverBelowHeader();
        }
    }, { passive: true });

    window.addEventListener('resize', function () {
        if (popover.classList.contains('is-open')) {
            positionPopoverBelowHeader();
        }
    });

    function closePopover() {
        clearTimeout(dismissTimeout);
        dismissTimeout = null;
        isTimerPaused = false;
        popover.classList.remove('is-open', 'is-loading', 'is-error', 'has-errors');
        popover.removeAttribute('aria-busy');
    }

    popover.addEventListener('mouseenter', pauseTimer);
    popover.addEventListener('mouseleave', resumeTimer);
    closeBtn && closeBtn.addEventListener('click', closePopover);
    continueBtn && continueBtn.addEventListener('click', closePopover);

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popover.classList.contains('is-open')) {
            closePopover();
        }
    });

    function resetQuantityInput(select) {
        if (!select) {
            return;
        }

        select.value = '0';
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function submitItems(items, onSuccess) {
        if (isSubmitting) {
            return;
        }

        isSubmitting = true;
        openPopoverLoading();

        fetch(getAjaxUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'add_to_cart_popover',
                security: getNonce(),
                items: JSON.stringify(items),
            }),
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                if (!response.success) {
                    const messages = (response.data && response.data.errors && response.data.errors.length)
                        ? response.data.errors
                        : [(response.data && response.data.message) || genericErrorMessage];
                    openPopoverError(messages);
                    return;
                }

                const errors = (response.data && response.data.errors) ? response.data.errors : [];
                const items = (response.data && response.data.items) ? response.data.items : [];

                updateCartCount(response.data.cart_items_count);

                // Complete failure is handled above via !response.success.
                if (!items.length) {
                    openPopoverError(errors.length ? errors : [genericErrorMessage]);
                    return;
                }

                openPopover(response.data);

                // Only reset quantity fields for products that were actually added.
                if (onSuccess) {
                    onSuccess(items);
                }
            })
            .catch(function () {
                openPopoverError([genericErrorMessage]);
            })
            .finally(function () {
                isSubmitting = false;
            });
    }

    // Per-row add-to-cart forms: product page table + account swatches table
    // (both use the same markup/classnames).
    document.querySelectorAll('.c-product-simple-products__table__row__cart').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            const idInput = form.querySelector('input[name="add-to-cart"]');
            const quantitySelect = form.querySelector('select[name="quantity"]');
            const quantity = quantitySelect ? parseInt(quantitySelect.value, 10) : 0;

            if (!idInput || !quantity || quantity < 1) {
                return;
            }

            e.preventDefault();

            submitItems([{
                product_id: parseInt(idInput.value, 10),
                quantity: quantity,
            }], function () {
                resetQuantityInput(quantitySelect);
            });
        });
    });

    // Bulk "Voeg selectie toe aan winkelwagen" form on the product page.
    document.querySelectorAll('.c-product-simple-products__order-all').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            const hiddenInputs = form.querySelectorAll('.js-product-multiple-input-hidden');
            const items = [];

            hiddenInputs.forEach(function (input) {
                const quantity = parseInt(input.value, 10);
                const match = input.name.match(/quantity\[(\d+)]/);

                if (match && quantity > 0) {
                    items.push({
                        product_id: parseInt(match[1], 10),
                        quantity: quantity,
                    });
                }
            });

            if (!items.length) {
                return;
            }

            e.preventDefault();

            submitItems(items, function (addedItems) {
                const addedIds = addedItems.map(function (item) {
                    return String(item.id);
                });

                document.querySelectorAll('.c-product-simple-products select[name="quantity"]').forEach(function (select) {
                    const container = select.closest('.js-input-container');

                    if (!container || !container.dataset.id) {
                        return;
                    }

                    if (!addedIds.includes(String(container.dataset.id))) {
                        return;
                    }

                    resetQuantityInput(select);
                });

                form.querySelectorAll('.js-product-multiple-input-hidden').forEach(function (input) {
                    const match = input.name.match(/quantity\[(\d+)]/);

                    if (!match || !addedIds.includes(match[1])) {
                        return;
                    }

                    input.value = '0';
                });
            });
        });
    });
});
